<template>
  <div class="study-details">
    <!-- <div class="scroll-content"> -->
    <div class="student-information">
      <div class="avatar">
        <img v-if="studentInfo.student.gender === 1" src="../../../assets/images/avator-woman.png" class="img-avator-woman" draggable="false" />
        <img v-else src="../../../assets/images/avator-man.png" class="img-avator-man" draggable="false" />
      </div>
      <div class="infos">
        <div class="header">
          <div class="left">
            <span>{{studentInfo.student.name}}</span>
            <img v-if="studentInfo.student.gender === 1" src="../../../assets/images/woman.png" class="img-avator-gender" draggable="false" />
            <img v-else src="../../../assets/images/man.png" class="img-avator-gender" draggable="false" />
          </div>
          <div class="right">
            <img src="../../../assets/images/alarm-clock.png" class="img-last-login-time" draggable="false" />
            <span>上次登录时间：{{studentInfo.student.loginTime || '&nbsp;'}}</span>
          </div>
        </div>
        <div class="content">
          <div class="info">专业：<span class="black">{{studentInfo.student.profressionName}}</span></div>
          <div class="info">学号：<span class="black">{{studentInfo.student.gender === 1 ? '女' : '男'}}</span></div>
          <div class="info">手机：<span class="black">{{studentInfo.student.account}}</span></div>
        </div>
      </div>
    </div>
    <div class="scroll-content"> 
      <div class="title-card">
        <div class="card-header">
          <div class="bar"></div>
          <div class="title">任务点学习统计</div>
          <div class="tips">最近提交时间：{{formatDate(studentInfo.user.updateTime)}}（该学习进度将于每日凌晨更新~）</div>
        </div>
        <div class="card-content learning-statistics-content">
          <div class="analysis-content">
            <div class="annular-panel" v-for="(option, key) in chartsOptions" :key="key">
              <div class="panel-pie-chart">
                <div class="pie-chart"
                  :style="{
                    '--progress': `${option.chartData}%`,
                    '--start--color': option.colorSchemes.finished,
                    '--end--color': option.colorSchemes.unfinished
                  }"
                ></div>
              </div>
              <div class="panel-describe" :style="{color: option.describeData.color}">
                <div class="title">{{option.describeData.title}}</div>
                <div class="data">{{option.describeData.data}}</div>
              </div>
            </div>
          </div>
          <div class="task-table">
            <div class="search-panel">
              <el-form ref="taskSearchForm" :model="taskSearchForm" inline>
                <el-form-item prop="name">
                  <el-select style="width:160px; marginLeft: 13px" v-model="taskSearchForm.taskType" placeholder="请选择" size="small">
                    <el-option label="任务点小节" :value="1" ></el-option>
                    <el-option label="非任务点小节" :value="0" ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item  prop="class">
                  <el-input v-model="taskSearchForm.name" placeholder="搜索小节序号或名称" clearable size="medium">
                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                  </el-input>
                </el-form-item>
                <el-form-item>
                  <div class="search-btn" @click="taskSearch()" >搜索</div>
                </el-form-item>
              </el-form>
            </div>
            <div class="table-study-detail">
              <el-table ref="studyTable" :height="studyTableHeight" :data="studyTableData.list"
                border :header-cell-style="{background:'#EBF3FF', color:'#4F6389'}"
                @sort-change="handleSortChange"
              >
                <el-table-column prop="levelPath" label="小节名称" sortable='custom'>
                  <template v-slot="{ row }">
                    {{row.levelPath +'&nbsp;'+ row.directoryName}}
                  </template>
                </el-table-column>
                <el-table-column label="视频完成进度" align="center">
                  <template v-slot="{ row }">
                    <div v-if="!row.videoStatus">/</div>
                    <div v-else class="table-charts-panel">
                      <div class="table-pie-chart">
                        <div class="pie-chart" :style="{ '--progress': `${row.videoRate}%` }"></div>
                      </div>
                      <div class="table-pie-data">{{row.videoRate}}%</div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="理论题正确率" align="center">
                  <template v-slot="{ row }">
                    <div v-if="!row.questionStatus">/</div>
                    <div v-else class="table-charts-panel">
                      <div class="table-bar-chart">
                        <div class="bar-chart" :style="{width: `${row.questionRate}%`}"></div>
                      </div>
                      <div class="table-bar-data">{{row.questionRate}}%</div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="病例题正确率（影像学表现/诊断）" align="center" width="360px">
                  <template v-slot="{ row }">
                    <div v-if="!row.studyStatus">/</div>
                    <div v-else class="table-charts-panel">
                      <div class="table-bar-chart">
                        <div class="bar-chart" :style="{width: `${row.studyFindRate}%`}"></div>
                      </div>
                      <div class="table-bar-data">{{row.studyFindRate}}%</div>
                      <div class="table-bar-chart">
                        <div class="bar-chart" :style="{width: `${row.studyRate}%`}"></div>
                      </div>
                      <div class="table-bar-data">{{row.studyRate}}%</div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="updateTime" label="本节最近提交时间" sortable align="center">
                  <template slot-scope="{ row }"><span>{{ formatDate(row.updateTime) }}</span></template>
                </el-table-column>
              </el-table>
              <div class="pagination-panel">
                <el-pagination
                  :current-page="studyTableData.pagination.currentPage"
                  :page-size="studyTableData.pagination.pageSize"
                  :page-sizes="[5, 10, 20, 30, 40, 50]"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="studyTableData.pagination.total"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  background
                ></el-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="title-card">
        <div class="card-header">
          <div class="bar"></div>
          <div class="title">考试成绩</div>
        </div>
        <div class="card-content exam-score-content">
          <div class="score-table">
            <el-table ref="scoreTableList" :height="scoreTableHeight" :data="scoreTableData" border
              :header-cell-style="{background:'#EBF3FF', color:'#4F6389'}" class="study-detail-table" >
              <el-table-column prop="studentNo" label="考试名称" align="center"></el-table-column>
              <el-table-column prop="name" label="考试开始时间" align="center"></el-table-column>
              <el-table-column prop="name" label="考试用时" align="center"></el-table-column>
              <el-table-column prop="account" label="考试提交时间" align="center"></el-table-column>
              <el-table-column prop="account" label="考试分数" align="center" width="360px"></el-table-column>
              <el-table-column label="本场考试排名" align="center">
                <template slot-scope="{ row }"><span>{{ formatDate(row.createTime) }}</span></template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { comMethod } from '@/utils/index.js'
import { formatDate } from '@/utils/formatDate.js';
import { studentCenterServer } from '@/api/api';
export default {
  name: 'StudyDetails',
  data () {
    return {
      studentId: this.$route.query.id,
      studentInfo: {
        student: {},
        total: {},
        user: {}
      },
      // 图表
      chartsOptions: {
        subsection: {
          chartData: '',
          describeData: {
            title: '小节进度',
            data: '',
            color: '#D48806'
          },
          colorSchemes: { // 黄
            finished: '#FFD067',
            unfinished: '#f9e7b7',
          }
        },
        video: {
          chartData: '',
          describeData: {
            title: '视频进度',
            data: '',
            color: '#08979C'
          },
          colorSchemes: { // 青
            finished: '#13C2C2',
            unfinished: '#CBE8EE',
          }
        },
        theory: {
          chartData: '',
          describeData: {
            title: '理论题进度',
            data: '',
            color: '#003CAB'
          },
          colorSchemes: { // 蓝
            finished: '#366EF4',
            unfinished: '#bac7ef',
          }
        },
        illness: {
          chartData: '',
          describeData: {
            title: '病例题进度',
            data: '',
            color: '#531DAB'
          },
          colorSchemes: { // 紫
            finished: '#722ED1',
            unfinished: '#EFDBFF',
          }
        }
      },
      taskSearchForm: {
        taskType: 1,
        name: ''
      },
      studyTableData: {
        list: [],
        pagination: {
          currentPage: 1,
          pageSize: 10,
          total: 0
        }
      },
      studyTableHeight: 351,
      // scoreTableHeight: 105,
      // scoreTableHeight: 255,
      scoreTableHeight: 133,
      scoreTableData: [],
      studyTableSort: {
        sortType: 1,
        sort: 0
      }
    }
  },
  created () {
    this.getStudyTableData();
    this.getStudentInformation();
    // this.studyTableHeight = comMethod.getTableHeight(594);
  },
  methods: {
    formatDate,
    async getStudyTableData(currentPage = 1) {
      try {
        const backendParams = {
          userId: this.studentId,
          ...this.taskSearchForm,
          page: currentPage,
          rows: this.studyTableData.pagination.pageSize,
          sortType: this.studyTableSort.sortType, 
          sort: this.studyTableSort.sort
        };
        const res = await studentCenterServer.studentAnalysisChapterList({...backendParams});
        const { code, data, message } = res;
        if (code === '0') {
            const list = data ? data.records : [];
            const total = data ? data.total : 0;
            this.studyTableData.list = list;
            this.studyTableData.pagination.total = total;
        } else {
          this.$message.error(message);
        }
      } catch (error) {
        this.$message.error(error);
      }
    },
    async getStudentInformation() {
      try {
        const backendParams = {
          userId: this.studentId,
        };
        const res = await studentCenterServer.studentAnalysisDetail({ ...backendParams });
        const { code, data, message } = res;
        if (code === '0') {
          this.studentInfo = data;
          this.setChartsOptions(data.user, data.total);
        } else {
          this.$message.error(message);
        }
      } catch (error) {
        this.$message.error(error);
      }
    },
    setChartsOptions(user, total) {
      this.chartsOptions.subsection.chartData = total.sectionNum !== 0 ? (user.sectionNum / total.sectionNum *100).toFixed(2) : 0;
      this.chartsOptions.video.chartData = total.videoNum !== 0 ? (user.videoNum / total.videoNum *100).toFixed(2) : 0;
      this.chartsOptions.theory.chartData = total.questionNum !== 0 ? (user.questionNum / total.questionNum *100).toFixed(2) : 0;
      this.chartsOptions.illness.chartData = total.studyNum !== 0 ? (user.studyNum / total.studyNum *100).toFixed(2) : 0;
      this.chartsOptions.subsection.describeData.data = `${user.sectionNum}/${total.sectionNum}` || '0/0';
      this.chartsOptions.video.describeData.data = `${user.videoNum}/${total.videoNum}` || '0/0';
      this.chartsOptions.theory.describeData.data = `${this.chartsOptions.theory.chartData}%`;
      this.chartsOptions.illness.describeData.data = `${user.studyNum}/${total.studyNum}` || '0/0';
    },
    taskSearch (currentPage = 1) {
      this.getStudyTableData(currentPage);
    },
    // pageSize 改变时会触发
    handleSizeChange (val) {
      this.studyTableData.pagination.pageSize = val;
      this.studyTableData.pagination.currentPage = 1;
      this.taskSearch();
    },
    // currentPage 改变时会触发
    handleCurrentChange (currentPage) {
      this.studyTableData.pagination.currentPage = currentPage
      this.taskSearch(currentPage);
    },
    handleSortChange({prop, order}) {
      this.studyTableData.pagination.currentPage = 1;
      this.studyTableSort.sortType = prop === 'levelPath' ? 0 : 1;
      this.studyTableSort.sort = order === 'ascending' ? 1 : 0;
      this.taskSearch();
    }
  }
}
</script>

<style lang="scss" scoped>
.study-details {
  width: 100%;
  overflow-y: auto;
  border-radius: 16px;
  padding: 24px 4px;
  background: rgba(255, 255, 255, 0.8);
  .student-information {
    margin: 0 20px;
    height: 88px;
    width: calc(100% - 40px);
    display: flex;
    border-bottom: 2px solid #E1EBF6;
    .avatar {
      height: 72px;
      width: 72px;
      margin-right: 25px;
      .img-avator-woman {
        height: 100%;
        width: 100%;
      }
      .img-avator-man {
        height: 100%;
        width: 100%;
      }
    }
    .infos {
      width: calc(100% - 97px);
      margin-top: 10px;
      .header {
        display: flex;
        justify-content: space-between;
        .left {
          font-size: 22px;
          font-weight: bold;
          color: #000000;
          display: flex;
          align-items: center;
          .img-avator-gender {
            width: 18px;
            height: 18px;
            margin-left: 8px;
          }
          span {
            font-family: AlimamaShuHeiTi;
          }
        }
        .right {
          display: flex;
          align-items: center;
          font-family: PingFang SC;
          font-size: 16px;
          font-weight: normal;
          .img-last-login-time {
            width: 16px;
            height: 16px;
            margin-right: 6px;
          }
          span {
            font-family: PingFang SC;
          }
        }
      }
      .content {
        margin-top: 6px;
        display: flex;
        .info {
          font-size: 16px;
          margin-right: 16px;
          font-family: PingFang SC;
          .black {
            font-family: PingFang SC;
            color: #000000;
          }
        }
      }
    }
  }
  .scroll-content {
    height: calc(100vh - 206px);
    overflow-y: auto;
    padding: 0 20px;
    .title-card {
      .card-header {
        height: 42px;
        display: flex;
        align-items: center;
        .bar {
          width: 4px;
          height: 16px;
          border-radius: 40px;
          background: #0052D9;
          margin-right: 8px;
        }
        .title {
          font-family: AlimamaShuHeiTi;
          font-size: 18px;
          font-weight: bold;
          color: #000000;
        }
        .tips {
          font-family: PingFang SC;
          font-size: 14px;
          font-weight: normal;
          color: #4F6389;
          margin-left: 16px;
        }
      }
      .card-content {
        background: #FFFFFF;
        border-radius: 16px;
      }
    }
    .learning-statistics-content {
      .analysis-content {
        height: 128px;
        border-bottom: 2px solid #E1EBF6;
        display: flex;
        align-items: center;
        justify-content: space-around;
        .annular-panel {
          position: relative;
          display: flex;
          .panel-pie-chart {
            width: 56px;
            height: 56px !important;
            position: relative;
            .pie-chart {
              width: 100%;
              height: 100%;
              border-radius: 50%;
              background: conic-gradient(var(--start--color) var(--progress), var(--end--color) 0deg);
              position: relative;
              &::after {
                content: '';
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 50%;
                height: 50%;
                border-radius: 50%;
                // background-color: #f5f8fd;
                background-color: #ffffff;
              }
            }
          }
          .panel-describe {
            font-family: PingFang SC;
            font-weight: 600;
            margin-left: 8px;
            text-align: left;
            .title {
              font-family: PingFang SC;
              font-size: 16px;
              margin-top: 4px;
            }
            .data {
              font-family: PingFang SC;
              font-size: 24px;
              margin-top: 3px;
            }
          }
        }
      }
      .task-table {
        height: 480px;
        .search-panel {
          text-align: left;
          padding: 16px 6px;
          .search-btn {
            display: inline-block;
            width: 60px;
            height: 32px;
            border-radius: 8px;
            cursor: pointer;
            border: 1px solid #D0DFFB;
            color: #0052D9;
            font-family: PingFang SC;
            font-size: 14px;
            line-height: 30px;
            margin-left: 2px;
            text-align: center;
          }
          /deep/ .el-form-item {
            margin-bottom: 0px;
          }
          /deep/ .el-input__inner {
            font-family: PingFang SC;
            width: 328px;
            height: 32px;
            border-radius: 8px;
            border: 1px solid #D0DFFB;
            // color: #AAB4D2;
          }
          /deep/ .el-select {
            .el-input__inner {
              width: 160px;
              border-radius: 4px;
              color: #4F6389;
            }
          }
        }
        .table-study-detail {
          padding: 0 16px;
          .table-charts-panel {
            height: 44px;
            // border: 1px solid black;
            display: flex;
            align-items: center;
            justify-content: center;
            .table-pie-chart {
              width: 26px;
              height: 26px !important;
              position: relative;
              .pie-chart {
                width: 100%;
                height: 100%;
                border-radius: 50%;
                background: conic-gradient(#366EF4 var(--progress), #c5d2fa 0deg);
                position: relative;
                &::after {
                  content: '';
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%, -50%);
                  width: 50%;
                  height: 50%;
                  border-radius: 50%;
                  // background-color: #f5f8fd;
                  background-color: #ffffff;
                }
              }
            }
            .table-pie-data {
              font-size: 16px;
              color: #003CAB;
              margin-left: 8px;
              width: 60px;
              // text-align: left;
            }
            .table-bar-chart {
              width: 80px;
              height: 8px;
              border-radius: 4.5px;
              background: #daead1;
              .bar-chart {
                height: 100%;
                border-radius: 4.5px;
                background: #439613;
              }
            }
            .table-bar-data {
              font-size: 16px;
              color: #358C05;
              margin: 0 8px;
              width: 60px;
              // text-align: left;
            }
          }
        }
        .pagination-panel {
          margin: 12px 0;
          text-align: right;
          /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
            background: #2B5EEF;
          }
          /deep/ .el-pagination.is-background .btn-next, /deep/ .el-pagination.is-background .btn-prev, /deep/ .el-pagination.is-background .el-pager li {
            border-radius: 8px;
          }
          /deep/ .el-pagination__jump {
            font-family: PingFang SC;
            font-size: 14px;
            margin-left: 14px;
          }
          /deep/ .el-pagination__total {
            font-family: PingFang SC;
            font-size: 14px;
          }
          /deep/ .el-pagination__sizes .el-input .el-input__inner {
            font-family: PingFang SC;
          }
        }
        /deep/ .el-table .el-table__cell {
          padding: 8px 0px;
          .cell {
            font-family: 'PingFang SC';
            font-size: 16px;
          }
        }
        /deep/ .el-table th.el-table__cell {
          padding: 6px 0px;
        }
      }
    }
    .exam-score-content {
      .score-table {
        // height: 137px;
        height: 287;
        padding: 16px;
        /deep/ .el-table .el-table__cell {
          .cell {
            font-family: 'PingFang SC';
            font-size: 16px;
          }
        }
        /deep/ .el-table th.el-table__cell {
          padding: 6px 0px;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/classCenter/StudyDetails/index.vue